export default __webpack_public_path__ + "static/media/Arrow_Down_2.74417aad.svg";